// 导入样式文件
import './Upload.less';
// 导入React hooks
import { useRef, useState, useCallback, useEffect } from 'react';
// 导入上传工具类
import Uploader from '@/utils/uppyUpload';
// 导入自定义Icon组件
import Icon from '@/components/iconfont/Icon.jsx';
// 导入文件输入图片
import FileInputImg from '@/assets/aivoices/popup/FileInput.png';
import SlideFileImg from '@/assets/assets/slide-file.png';
import message from '@/utils/message.jsx';
import { useTranslation } from 'react-i18next';
// 上传组件
export default function Upload({ value }) {
  const { t } = useTranslation();
  const {
    uploadPupUpModal,
    setUploadPupUpModal,
    onUploadSuccess,
    accept,
    text,
    maxSize,
    usage,
    type,
  } = value;
  const [fileData, setFileData] = useState(null);
  const [uploadFlag, setUploadFlag] = useState(false);
  const [progressNum, setProgressNum] = useState(0);
  const [uploadInstance, setUploadInstance] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [imgUrl, setImgUrl] = useState('');
  // 创建对话框的引用
  const PopUpRef = useRef(null);
  const UploadRef = useRef(null);

  // 处理关闭弹窗的回调函数
  const handleClose = useCallback(() => {
    console.log('弹窗已关闭');
    UploadRef.current.value = '';
    setUploadPupUpModal(false);
  }, [setUploadPupUpModal]);

  // 处理弹窗显示和关闭事件的副作用
  useEffect(() => {
    if (uploadPupUpModal) {
      PopUpRef.current.show();
    } else {
      if (uploadInstance) {
        uploadInstance.stop();
      }
      PopUpRef.current.close();
      setProgressNum(0);
      setFileData(null);
      setUploadFlag(false);
    }
    const dialogElement = PopUpRef.current;
    // 如果对话框元素存在，添加关闭事件监听器
    if (dialogElement) {
      dialogElement.addEventListener('close', handleClose);
    }

    // 清理函数
    return () => {
      // 如果对话框元素存在，移除关闭事件监听器
      if (dialogElement) {
        dialogElement.removeEventListener('close', handleClose);
      }
    };
  }, [handleClose, uploadPupUpModal, uploadInstance]);

  // 上传进度回调
  const handleProgress = (val) => {
    setProgressNum(val);
  };

  // 处理文件选择
  const handleUploadAvatar = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      event.target.value = '';
      setFileData(null);
      console.log('message提醒：请选择文件');
      return;
    }
    const allowedExtensions = accept.replace(/\./g, '').split(',');
    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      if (type === 'assets_videos') {
        message.warning('Only MP4 files are supported');
      }
      if (type === 'assets_slides') {
        message.warning('Only PPT, PDF, PPTX files are supported');
      }
      event.target.value = '';
      setFileData(null);
      return;
    }
    if (file.size > maxSize) {
      if (type === 'assets_videos') {
        message.warning('Please upload a file smaller than 1GB');
      }
      if (type === 'assets_slides') {
        message.warning('Please upload a file smaller than 500MB');
      }
      event.target.value = '';
      setFileData(null);
      return;
    }
    // 截取文件名前200个字符
    const fileNameParts = file.name.split('.');
    const extension = fileNameParts.pop();
    const baseName = fileNameParts.join('.');
    const maxBaseLength = 200 - extension.length - 1; // -1 for the dot
    const fileName =
      baseName.length > maxBaseLength
        ? baseName.substring(0, maxBaseLength) + '.' + extension
        : file.name;
    const newfile = new File([file], fileName, { type: file.type });
    setFileData(newfile);
    // 如果是视频文件,创建预览URL
    if (newfile.type.startsWith('video/')) {
      const videoUrl = URL.createObjectURL(newfile);
      setPreviewUrl(videoUrl);
      // 组件卸载时清理URL
      return () => URL.revokeObjectURL(videoUrl);
    }
    if (newfile.type.startsWith('audio/')) {
      setImgUrl(FileInputImg);
    }
    // 如果不是视频文件，创建图片预览URL
    if (!newfile.type.startsWith('video/') && !file.type.startsWith('audio/')) {
      setImgUrl(SlideFileImg);
    }
  };

  // 关闭弹窗
  const handleClosePopUp = () => {
    PopUpRef.current.close();
  };

  // 处理文件上传
  const handleUpload = async () => {
    setUploadFlag(true);
    handleProgress(0);
    // const fileExtension = fileData.name.split('.').pop().toLowerCase();
    const fileInfo = {};
    if (usage === 4) {
      fileInfo.filename = fileData.name;
    } else if (![0, 1, 3].includes(usage)) {
      throw new Error('No usage');
    }

    const uploader = new Uploader(usage, fileInfo);
    setUploadInstance(uploader);
    uploader.on('progress', handleProgress);
    uploader.on('success', (res) => {
      onUploadSuccess(res, fileData);
      setUploadInstance(null);
      handleClosePopUp();
    });
    uploader.on('failed', () => {
      uploader.retry();
    });
    uploader.on('retry-failed', () => {
      setUploadFlag(false);
      message.error('Upload failed, please try again', {
        id: 'upload-asset-failed',
      });
    });
    uploader.uploadFileWithSlice(fileData);
  };

  return (
    <div className="upload_file_modal_pop_up_box">
      <dialog ref={PopUpRef} className="modal">
        <div className="modal-box min-w-[520px]">
          <form method="dialog">
            <button
              data-tip="Close modal will cancel the uploading"
              className={`btn btn-sm btn-circle btn-ghost absolute right-2 top-2 close_icon_btn ${uploadFlag && 'tooltip'} tooltip-warning`}>
              <Icon name="icon-close-stroke" />
            </button>
          </form>
          <div className="upload_file_modal_pop_up_main">
            <div className="title">
              {/* Upload */}
              {t('As_Uploads_Title')}
            </div>
            <div className="upload_box">
              {fileData ? (
                <AlreadyUploaded
                  fileData={fileData}
                  previewUrl={previewUrl}
                  imgUrl={imgUrl}
                  uploadFlag={uploadFlag}
                  progressNum={progressNum}
                />
              ) : (
                <NotUploaded text={text} />
              )}
              <input
                ref={UploadRef}
                onChange={handleUploadAvatar}
                type="file"
                accept={accept}
                className="file-input file-input-bordered file-input-xs uploadinput"
              />
            </div>
            <div className="btnbox">
              {uploadFlag ? (
                <button className="btn btn-primary btn-sm uploading_btn" disabled>
                  <div className="spot_box">
                    {/* Uploading */}
                    {t('As_CreateVoice_Uploading')}
                    <span className="spot_list">
                      <span className="spot">·</span>
                      <span className="spot">·</span>
                      <span className="spot">·</span>
                    </span>
                  </div>
                </button>
              ) : (
                <>
                  <button className="btn btn-ghost btn-sm" onClick={handleClose}>
                    {/* Cancel */}
                    {t('As_CreateVoice_Cancel')}
                  </button>
                  {fileData && (
                    <button className="btn btn-primary btn-sm" onClick={handleUpload}>
                      {/* Upload */}
                      {t('As_Home_NavTitle2')}
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
}
// 未上传状态的组件
function NotUploaded({ text }) {
  const { t } = useTranslation();
  return (
    <div className="not_uploaded">
      <Icon name="icon-upload" className="icon" />
      <div className="upload_text">
        {/* Drop your file here, or&nbsp;
        <span>click to browse</span> */}
        {t('As_CreateProjectTrans_LocalDes1')}&nbsp;
        <span>
          {/* click to browse */}
          {t('As_CreateProjectTrans_LocalDes2')}
        </span>
      </div>
      <div className="rules">{t(text)}</div>
    </div>
  );
}

// 已上传状态的组件
function AlreadyUploaded({ fileData, previewUrl, imgUrl, uploadFlag, progressNum }) {
  const { t } = useTranslation();
  return (
    <div className="already_uploaded">
      {fileData.type.startsWith('video/') ? (
        <video src={previewUrl} className="file_input_img"></video>
      ) : (
        <img src={imgUrl} alt="" className="file_input_img" />
      )}

      <div className="file_name">{fileData?.name}</div>
      {uploadFlag ? (
        <progress className="progress progress-primary w-56" value={progressNum} max="1"></progress>
      ) : (
        <button className="btn btn-sm">
          {/* Re-upload */}
          {t('As_CreateVoice_Reupload')}
        </button>
      )}
    </div>
  );
}
